import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  cards: [],
  district: null,
  filteredCardData: [],
  cardTotalItems: null,
  cardPagination: {
    current_page: 1,
    last_page: 0,
    rowsPerPage: 16
  },

}

// mutations
export const mutations = {
  [types.SET_CARDS] (state, payload) {
    state.cards = payload.data
    state.cardTotalItems = payload.total

    state.cardPagination.current_page = payload.current_page
    state.cardPagination.last_page = payload.last_page
    state.cardPagination.rowsPerPage = payload.per_page
  },
  filteredCards(state, data){
    state.filteredCardData = data

  }
}

// actions
export const actions = {
  async fetchCards ({ commit }, payload) {
    try {
      const { data } = await axios.get(`/api/cards`,{
        params: payload ? payload.query : ''
      })
      commit(types.SET_CARDS, data)
    } catch (e) {
      console.log(e)
    }
  }
}

// getters
export const getters = {
  cards: state => state.cards,
  filteredCardsData: state => state.filteredCardData,
  cardTotalItems: state => state.cardTotalItems,
  cardPagination : state=>state.cardPagination
}




// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/card.js